// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const isServer = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};

  if (isServer) {
    // eslint-disable-next-line import/extensions
    Components.Page = (await import('./pages/Page.jsx')).Page;
  }

  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  home: {
    name: 'Page',
    componentName: 'Page',
    chunk: () => import('./pages/Page'),
    get component() {
      return isServer
        ? serverPages.Page
        : currentRouteName === 'Page'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Page })));
    },
    path: ["/:context?/p/:slug?/:itemId/*"],
    channel: null
  },
});
